import React, {Fragment, useEffect} from 'react'
import {useIdleTimer} from "react-idle-timer";

const APP_TIMEOUT_MINUTES = 120 ;
export const APP_TIMEOUT = 60 * 1000 * APP_TIMEOUT_MINUTES ;

const IdleTimeoutWrapper = ({children, logout_url}) =>
{
    const onIdle = () =>
    {
        window.location.replace(logout_url);
    }

    const onActive = (event) => {
    }

    const { start } = useIdleTimer({
        timeout: APP_TIMEOUT,
        startManually: true,
        onIdle,
        onActive })

    useEffect(() => {
        // Start the inactivity timer
        start() ;
    }, []);

    return (
        <Fragment>
            { children }
        </Fragment>
    )
}

export default IdleTimeoutWrapper ;
